import { useStore } from '@nanostores/react';
import { themeStore } from '~/lib/stores/theme';

export function DialogLogo() {
  const theme = useStore(themeStore);

  return (
    <div
      className="mb-12 min-h-30 relative"
      style={{
        background:
          theme === 'light'
            ? 'radial-gradient(173.49% 176.64% at 93.92% 0%, rgba(75, 165, 247, 0.4) 0%, rgba(75, 165, 247, 0) 100%), radial-gradient(118.61% 120.76% at 15.5% 100%, rgba(27, 29, 59, 0) 0%, rgba(27, 29, 59, 0) 100%), radial-gradient(119.09% 121.25% at 96.22% 100%, rgba(224, 178, 244, 0.7) 0%, rgba(224, 178, 244, 0) 100%)'
            : 'radial-gradient(173.49% 176.64% at 93.92% 0%, rgba(75, 165, 247, 0.1) 0%, rgba(75, 165, 247, 0) 100%), radial-gradient(118.61% 120.76% at 15.5% 100%, #1B1D3B 0%, rgba(27, 29, 59, 0) 100%), radial-gradient(119.09% 121.25% at 96.22% 100%, rgba(224, 178, 244, 0.1) 0%, rgba(224, 178, 244, 0) 100%)',
      }}
    >
      <div
        className="absolute bottom-0 w-100% h-px"
        style={{
          background: 'linear-gradient(270deg, #4BA5F7 0%, #DEADF3 100%)',
          opacity: theme === 'light' ? 1 : 0.3,
        }}
      />
      <div className="absolute top-65% left-0 right-0 ml-auto mr-auto w-20 h-20 p-4 rounded-4 bg-black flex justify-center">
        <div className="i-bolt:logos-github?mask w-12 h-12 bg-white" />
      </div>
    </div>
  );
}
